import { NgModule } from '@angular/core';
import { DynamicComponentLoaderModule } from '@local/ui-infra';
import { PreviewNotAvailableComponent } from './components/preview-not-available/preview-not-available.component';
import { PreviewErrorComponent } from './components/preview-error/preview-error.component';
import { PreviewContainerComponent } from './components/preview-container/preview-container.component';
import { SharedBarModule } from '../../components/shared-bar.module';
import { PreviewHubComponent } from './preview-hub/preview-hub.component';

const components = [PreviewNotAvailableComponent, PreviewErrorComponent, PreviewContainerComponent, PreviewHubComponent];
const modules = [SharedBarModule, DynamicComponentLoaderModule];
@NgModule({
  declarations: components,
  imports: modules,
  exports: [...components, ...modules],
})
export class PreviewModule {}
